export default __webpack_public_path__ + "static/media/outcess18.651ec45a.jpeg";